"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 16 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var WindowItem_1 = require("../model/WindowItem");

var WindowItemUpdateDTO_1 = require("../model/WindowItemUpdateDTO");

var WindowItemWarningFlag_1 = require("../model/WindowItemWarningFlag");

var MemberCreditsConverter_1 = require("./MemberCreditsConverter");

var WindowItemPosAttributesConverter_1 = require("./WindowItemPosAttributesConverter");

var WindowItemSimulationConverter_1 = require("./WindowItemSimulationConverter");

var WindowItemUpdateDTOConverter_1 = require("./WindowItemUpdateDTOConverter");
/**
 * Default implementation of WindowItemUpdateDTOConverter.
 *
 * @author JMt
 */


var WindowItemUpdateDTOConverterImpl =
/*#__PURE__*/
function (_WindowItemUpdateDTOC) {
  _inherits(WindowItemUpdateDTOConverterImpl, _WindowItemUpdateDTOC);

  function WindowItemUpdateDTOConverterImpl() {
    _classCallCheck(this, WindowItemUpdateDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemUpdateDTOConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemUpdateDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var result = new WindowItemUpdateDTO_1.WindowItemUpdateDTO(WindowItem_1.WindowItem.schema.id.valueOf(conversions.documentToClassId(source)), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'promoPrice', conversions.toBigNumber), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'regularPrice', conversions.toBigNumber), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'cmForecast', conversions.toBigNumber), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'systemVolume', conversions.toBigNumber), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'promoVolume', conversions.toBigNumber), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'requestSecondaryPlacement'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'secondaryPlacement'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'posAttributes', this.deserializePosAttributes(conversions)), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'memberCredits', this.deserializeMemberCredits(conversions)), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'logisticComment'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'returnable'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'returnableCondition'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'endDateOfReturn'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'distrModelId'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'distributionModelDays'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'lockType'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'selloutSales'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'ignoreForTraining'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'activeSale'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'extraSaleSticker'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'tastings'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'tvCommercial'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'onPicture'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'groupOfSitesId'), !utils_1.Utils.isUndefined(source.warningFlags) ? conversions.asFlagSet(source.warningFlags, WindowItemWarningFlag_1.WindowItemWarningFlag) : undefined, WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'substituteProductId'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'marketingComment'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'directDelivery'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'directDeliverySites'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'measureUnits'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'simulation', this.deserializeSimulation(conversions)), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'lastSystemVolumeUpdate'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'regularVolume'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'justInTime'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'lastPromoVolumeUpdate'), WindowItemUpdateDTOConverterImpl.valueOrUndefined(source, 'lastSystemVolumeComputationFailure'));
      return result;
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source)); //TODO metody instance nelze predavat timto zpusobem! pokud by pouzivaly this, tak to nebude fungovat, predelat na lambda funkce

      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'promoPrice', conversions.fromBigNumber);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'regularPrice', conversions.fromBigNumber);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'cmForecast', conversions.fromBigNumber);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'systemVolume', conversions.fromBigNumber);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'promoVolume', conversions.fromBigNumber);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'requestSecondaryPlacement');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'secondaryPlacement');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'posAttributes', this.serializePosAttributes(conversions));
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'memberCredits', this.serializeMemberCredits(conversions));
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'logisticComment');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'returnable');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'returnableCondition');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'endDateOfReturn', conversions.fromDate);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'distrModelId', conversions.toDocumentReferenceId);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'distributionModelDays');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'lockType');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'selloutSales');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'ignoreForTraining');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'activeSale');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'extraSaleSticker');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'tastings');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'tvCommercial');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'onPicture');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'groupOfSitesId', conversions.toDocumentReferenceId);

      if (!utils_1.Utils.isUndefined(source.warningFlags)) {
        Object.assign(result, {
          warningFlags: source.warningFlags.serialize()
        });
      }

      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'substituteProductId');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'marketingComment');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'directDelivery');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'directDeliverySites');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'measureUnits');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'simulation', this.serializeSimulation(conversions));
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'regularVolume');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'justInTime');
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'lastSystemVolumeUpdate', conversions.fromDate);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'lastPromoVolumeUpdate', conversions.fromDate);
      WindowItemUpdateDTOConverterImpl.assignIfDefined(result, source, 'lastSystemVolumeComputationFailure', conversions.fromDate);
      return result;
    }
  }, {
    key: "deserializePosAttributes",
    value: function deserializePosAttributes(conversions) {
      var _this = this;

      return function (document) {
        return _this.posAttributesConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializePosAttributes",
    value: function serializePosAttributes(conversions) {
      var _this2 = this;

      return function (object) {
        return _this2.posAttributesConverter.toDocument(object, conversions);
      };
    }
  }, {
    key: "deserializeMemberCredits",
    value: function deserializeMemberCredits(conversions) {
      var _this3 = this;

      return function (document) {
        return _this3.memberCreditsConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeMemberCredits",
    value: function serializeMemberCredits(conversions) {
      var _this4 = this;

      return function (object) {
        return _this4.memberCreditsConverter.toDocument(object, conversions);
      };
    }
  }, {
    key: "deserializeSimulation",
    value: function deserializeSimulation(conversions) {
      var _this5 = this;

      return function (document) {
        return _this5.simulationConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeSimulation",
    value: function serializeSimulation(conversions) {
      var _this6 = this;

      return function (object) {
        return _this6.simulationConverter.toDocument(object, conversions);
      };
    }
    /**
     * Get attribute value or set attribute as undefined
     * @param source
     * @param attribute
     * @param fn
     */

  }], [{
    key: "valueOrUndefined",
    value: function valueOrUndefined(source, attribute, fn) {
      if (utils_1.Utils.isUndefined(source[attribute])) {
        return undefined;
      } else {
        return fn ? WindowItem_1.WindowItem.schema[attribute].valueOf(fn(source[attribute])) : WindowItem_1.WindowItem.schema[attribute].valueOfField(source);
      }
    }
    /**
     * Assign attribute value if value is defined
     * @param obj
     * @param source
     * @param attribute
     * @param fn
     */

  }, {
    key: "assignIfDefined",
    value: function assignIfDefined(obj, source, attribute, fn) {
      if (!utils_1.Utils.isUndefined(source[attribute])) {
        obj[attribute] = source[attribute] === null ? null : fn ? fn(source[attribute]) : source[attribute];
      }
    }
  }]);

  return WindowItemUpdateDTOConverterImpl;
}(WindowItemUpdateDTOConverter_1.WindowItemUpdateDTOConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", WindowItemPosAttributesConverter_1.WindowItemPosAttributesConverter)], WindowItemUpdateDTOConverterImpl.prototype, "posAttributesConverter", void 0);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", MemberCreditsConverter_1.MemberCreditsConverter)], WindowItemUpdateDTOConverterImpl.prototype, "memberCreditsConverter", void 0);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", WindowItemSimulationConverter_1.WindowItemSimulationConverter)], WindowItemUpdateDTOConverterImpl.prototype, "simulationConverter", void 0);

exports.WindowItemUpdateDTOConverterImpl = WindowItemUpdateDTOConverterImpl;